import {
  PresentationGraphExtensionSchema,
  emptyPresentationExtension,
  type PresentationGraphExtension,
} from '@/domain/presentation/contracts';
import type { PresentationGraphInput } from '@/domain/presentation/graph-input';
import { getNodeDefinition } from '../nodes/registry/node-registry';
import type { EditorGraph } from '../domain/editor-graph';

/** SPEC-011 plan §38 — the bridge between EditorGraph and the framework-free `src/domain/presentation` engine, mirroring SPEC-009's `graph-bridge.ts`. */
export function toPresentationGraphInput(graph: EditorGraph): PresentationGraphInput {
  return {
    nodes: graph.nodes.map((node) => ({
      id: node.id,
      category:
        getNodeDefinition(node.type ?? '')?.category ??
        (node.data as { category?: string })?.category ??
        'documentation',
    })),
    edges: graph.edges.map((edge) => ({ id: edge.id, source: edge.source, target: edge.target })),
  };
}

/** §11/graph-schema.md §3 — reads the registered `presentation` extension, defaulting to empty (Zod boundary). */
export function readPresentationExtension(graph: EditorGraph): PresentationGraphExtension {
  const parsed = PresentationGraphExtensionSchema.safeParse(
    (graph as { presentation?: unknown }).presentation,
  );
  return parsed.success ? parsed.data : emptyPresentationExtension();
}
